module.exports = __webpack_public_path__ + "static/media/section_4_B.c23ab8dc.png";